import router from "../../router";
import * as types from "../mutation-types";

const state = {
	userIsLoggedIn: false,
	username: localStorage.username || "",
	userInfo: {},
	refreshTokenRequestIsActive: false
};

const getters = {
	userIsLoggedIn: state => state.userIsLoggedIn,
	username: state => state.username,
	userInfo: state => state.userInfo,
	refreshTokenRequestIsActive: state => state.refreshTokenRequestIsActive
};

const actions = {
	logout({ commit }) {
		Promise.all([
			localStorage.removeItem("access_token"),
			localStorage.removeItem("refresh_token"),
			commit(types.SET_USER_LOGGED_OUT)
		]).then(() => router.push({ name: "login" }));

	},
	setUsername({ commit }, username) {
		commit(types.SET_USERNAME, username);
	},
	setUserLoggedIn({ commit }) {
		commit(types.SET_USER_LOGGED_IN);
	},
	setUserLoggedOut({ commit }) {
		commit(types.SET_USER_LOGGED_OUT);
	},
	setRefreshTokenRequestActive({ commit }) {
		commit(types.SET_REFRESH_TOKEN_REQUEST_ACTIVE);
	},
	setRefreshTokenRequestInactive({ commit }) {
		commit(types.SET_REFRESH_TOKEN_REQUEST_INACTIVE);
	}
};

const mutations = {
	SET_USERNAME(state, username) {
		localStorage.setItem("username", username);
		state.username = username;
	},
	SET_USER_LOGGED_IN(state) {
		state.userIsLoggedIn = true;
	},
	SET_USER_LOGGED_OUT(state) {
		state.userIsLoggedIn = false;
	},
	SET_REFRESH_TOKEN_REQUEST_ACTIVE(state) {
		state.refreshTokenRequestIsActive = true;
	},
	SET_REFRESH_TOKEN_REQUEST_INACTIVE(state) {
		state.refreshTokenRequestIsActive = false;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/session.js